export const environment = {
  production: true,
  base_url: "https://backend.dev.s9trucks.com",
  base_uri: "/api/v1.0/",
  tile_server_url: "https://map.s9trucks.com/tiles/india",
  tile_api_key: "681d7082afa799a4c9da911f5866f65145d66709a24faf08ee2179a45b543f73",
  razorpay_key: "rzp_test_ImRDXx53av2Ens",
};
